<div class="modal-body">
  <div class="my-modal-header">
    <div class="my-modal-heading">
      <h4 id="modal-basic-title">{{'Request for collection and processing of personal data' | translate}}</h4>
      <p class="my-modal-hint">{{'Personal data request hint' | translate}}</p>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <img
        src="assets/icons/close-blue.svg"
        [attr.alt]="'alt.close' | translate"
      />
    </button>
  </div>

  <div class="request-fields">
    <div class="form-group">
      <app-floating-input
        type="text"
        id="iin"
        [maxlength]="12"
        [label]="'New member\'s IIN' | translate"
        [(ngModel)]="data.iin"
        [disabled]="loadingSearchIIN"
        [required]="true"
        (keyup)="data.iin && data.iin.length === 12 && !loadingSearchIIN ? onSearchIIN() : null"
      ></app-floating-input>
      <div class="error-message" *ngIf="isUserSearchError">{{'Errors.Incorrect TIN' | translate}}</div>
      <div class="error-message" *ngIf="iinIsRepeated">{{'Errors.User already added' | translate}}</div>
    </div>

    <!-- Пока ищем ФИО по ИИН — заглушка на месте будущей карточки, чтобы форма не прыгала. -->
    <div class="participant participant--loading" *ngIf="loadingSearchIIN" aria-busy="true">
      <span class="participant__avatar"></span>
      <span class="participant__info">
        <span class="participant__line participant__line--long"></span>
        <span class="participant__line"></span>
      </span>
    </div>

    <ng-container *ngIf="!loadingSearchIIN">
      <div class="participant" *ngFor="let user of users">
        <span class="participant__avatar" aria-hidden="true">{{ initials(user.fullName) }}</span>
        <span class="participant__info">
          <span class="participant__name">{{ user.fullName }}</span>
          <span class="participant__iin">{{ user.iin }}</span>
        </span>
        <button
          type="button"
          class="participant__remove"
          [attr.aria-label]="'Remove' | translate"
          [attr.title]="'Remove' | translate"
          (click)="removeUser(user)"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </ng-container>

    <div class="form-group mb-0">
      <app-floating-input
        type="textarea"
        id="comment"
        [label]="'Send commentary' | translate"
        [(ngModel)]="comment"
        [rows]="3"
      ></app-floating-input>
    </div>
  </div>

  <div class="my-modal-footer">
    <button type="button" class="btn cancel"
            (click)="onClose()">{{'Cancel request' | translate}}</button>
    <div>
      <app-button
        [className]="'btn btn-primary'"
        [loading]="loadingAddUser"
        [disabled]="!users.length || isCompanySearchError"
        (click)="sendRequest()"
      >
        {{ 'Send' | translate }}
      </app-button>
    </div>
  </div>
</div>
